var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.className
    ? _c("i", { class: ["bi", _setup.className], attrs: { title: _vm.type } })
    : _c("span", [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.type === "customscript" || _vm.type === "fieldset"
                ? ""
                : _vm.type
            ) +
            "\n"
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }